export default __webpack_public_path__ + "static/media/marketing-real-estate-freezer-background.eb3b01e2.svg";